import {
    deleteCalendarGroupConfirmationTitleText,
    deleteCalendarGroupConfirmationSubText,
} from './confirmAndDeleteCalendarGroup.locstring.json';
import { delete_0 } from 'owa-locstrings/lib/strings/delete_0.locstring.json';
import loc from 'owa-localize';
import { deleteCalendarGroup } from 'owa-calendar-update';
import { isFeatureEnabled } from 'owa-feature-flags';

import { confirm, DialogResponse } from 'owa-confirm-dialog';
import { confirmAndDeleteCalendarGroup } from '../actions/calendarGroupActions';
import { orchestrator } from 'satcheljs';

orchestrator(confirmAndDeleteCalendarGroup, async actionMessage => {
    const { userIdentity, calendarGroup, onDelete } = actionMessage;
    let isDeleted = false;

    if (
        isFeatureEnabled('cal-removeDeleteConfirmationDialog') ||
        (await confirm(
            loc(deleteCalendarGroupConfirmationTitleText),
            loc(deleteCalendarGroupConfirmationSubText),
            false,
            {
                okText: loc(delete_0),
                delayCallbackAfterAnimation: true,
            }
        )) == DialogResponse.ok
    ) {
        await deleteCalendarGroup(userIdentity, calendarGroup);
        isDeleted = true;
    }

    if (onDelete) {
        onDelete(isDeleted);
    }
});
